import { render, staticRenderFns } from "./ProfileWorkDetails.vue?vue&type=template&id=16e89b20&"
import script from "./ProfileWorkDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileWorkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports